module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Object type model")]), _vm._v(" "), _c('object-type-example'), _vm._v(" "), _c('h3', [_vm._v("String type model")]), _vm._v(" "), _c('string-type-example'), _vm._v(" "), _c('h3', [_vm._v("Number type model")]), _vm._v(" "), _c('number-type-example'), _vm._v(" "), _c('h3', [_vm._v("isError prop")]), _vm._v(" "), _c('error-prop-example'), _vm._v(" "), _c('h3', [_vm._v("isDisabled prop")]), _vm._v(" "), _c('disabled-prop-example')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54e41699!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sample/Model/Model.vue
// module id = 394
// module chunks = 2